(function () {
	'use strict';

	// ─── Fade in ────────────────────────────────────────────────────────────────
	// Ported from the luigetiigi site. Elements with the "fade-in" global class
	// (used on the eyebrow and lead text around animate-words headings) fade in
	// without moving when they scroll into view, and fade back out when scrolled
	// back above. Hidden until the tween exists (_fade-in.scss); .is-ready shows it.

	var SELECTOR = '.fade-in';

	document.addEventListener('DOMContentLoaded', function () {
		var elements = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
		if (!elements.length || !document.documentElement.classList.contains('arelis-motion')) {
			return;
		}

		var canAnimate = window.gsap && window.ScrollTrigger &&
			!window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		if (canAnimate) {
			window.gsap.registerPlugin(window.ScrollTrigger);
		}

		elements.forEach(function (el) {
			if (canAnimate) {
				// fromTo, not from: the CSS start state is opacity 0, which from() would tween to
				window.gsap.fromTo(el, { opacity: 0 }, {
					scrollTrigger: {
						trigger: el,
						start: 'top 90%',
						toggleActions: 'play none none reverse',
					},
					opacity: 1,
					duration: 1.5,
					ease: 'power2.out',
				});
			}
			el.classList.add('is-ready');
		});
	});

})();
